import { render } from "./userData.vue?vue&type=template&id=078ee5b6&scoped=true"
import script from "./userData.vue?vue&type=script&lang=js"
export * from "./userData.vue?vue&type=script&lang=js"

import "./userData.vue?vue&type=style&index=0&id=078ee5b6&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-078ee5b6"]])

export default __exports__